const MobilePagination = () => {
    $('.news-pagination__left, .news-pagination__right').on('click', e => {
        let target = e.currentTarget;

        if($(window).innerWidth() < 1024) {
            window.location = $(target).data('paginate');
        }
    })
}

export default MobilePagination;


// WEBPACK FOOTER //
// ./src/js/app/components/MobilePagination.js